
import {throwError as observableThrowError, Observable} from 'rxjs';

export class HttpErrorHaddle {
    static handleError(error: Response) {
        console.error(error);
        if (error.status === 404 || error.status >= 500) {
            return observableThrowError({error: 'Our server is experiencing some error, please try again later.'});
        } else if (error.status === 401 ) {
            return observableThrowError({error: 'Login Id or password is wrong, please try again later.'});
        }else if (error.status === 403) {
            return observableThrowError({error: 'Your login is expired, please logout and re-login.'});
        } else {
            return observableThrowError({error: 'Something wrong happens, please logout and re-login.'});
        }
    }
}